import React, { useEffect,useState, useCallback } from "react";
import { ImageBackground, StyleSheet, View, Image, Text, FlatList, Animated } from "react-native";
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
import Button from "../components/Button";
import routes from "../navigation/routes";
import CardHistory from "../components/CardHistory";
import { useFocusEffect } from '@react-navigation/native'
import dateNow from '../utility/dateNow';

var arrayUserHistory = []
var elementScroll = 0
var timerId
var refFlatList
var arrayPublications = []
var pageNumber = 0
var blockSize = 5
var pointer = 0
function HistoryScreen(props) {

  //Crea una referencia para poder utilizar propiedades de una etiqueta afuera en el area de funciones 
  refFlatList = React.createRef()
var date
useFocusEffect(
useCallback(() => {
    arrayUserHistory = []
    date = dateNow()
    console.log(';) ->', )
    pointer = 0
    arrayPublications = []
    pageNumber = 0
    blockSize = 5
    getHistorys()
   }, [])
)

var uriPublications =  connectionConfig.imageUrl + '/imagesPublications/'

   const [ items, setItems ] =  useState([]) // para que es 
  const getPublications = async () => {
    //debugger
    pointer = pageNumber * blockSize
   // setLoading(true)
  // console.log('ejemplo de ->', uriPublications)
    var post_values = {
      userId: props.userId,
      pointer: pointer,
      blockSize: blockSize
    }
    //establece parámetros de configurción del post
    configurationPost.body = JSON.stringify(post_values)
    //solicita el servicio para adquirir los pubicaciones del servidor
    await fetch(connectionConfig.apiUrl + '/fixoUserPublications/select', configurationPost)
      .then(response => response.json())
      .then(response => {
        //  console.log('ejemplo de ->',response.data )
        if (response.data.length === 0) {
          if (pageNumber > 0) {
           // setLoading(false)
          } else {
            //setPublicationSucces(false)
            ///setLoading(false)
          }
        } else {
          pageNumber++
          if (arrayPublications.length > 0) {
            arrayPublications = [...arrayPublications, ...response.data]
          } else {
            arrayPublications = response.data
          }

          setItems(arrayPublications)
          //setLoading(false)
         // setPublicationSucces(true)
        }
      })
      .catch(err => {
        console.log('getPublications failed :( review internet service)', err)
      })
  }
//---------------------------------------------
//servicio que va por las historias de los usuarios que sigues
//---------------------------------------------
  const getHistorys = async () => {
    //debugger
    //limpia el arraglo para no repetir
    if(arrayUserHistory.length > 0)
    {
      arrayUserHistory = []
    }
    pointer = pageNumber * blockSize
   // setLoading(true)
  // console.log('ejemplo de ->', uriPublications)
    var post_values = {
      userId: props.userId,
      pointer: pointer,
      blockSize: blockSize
    }
    //establece parámetros de configurción del post
    configurationPost.body = JSON.stringify(post_values)
    //solicita el servicio para adquirir los pubicaciones del servidor
    await fetch(connectionConfig.apiUrl + '/SelectHistorys/', configurationPost)
      .then(response => response.json())
      .then(response => {
        //  console.log('ejemplo de ->',response.data )
        if (response.data.length === 0) {
          if (pageNumber > 0) {
           // setLoading(false)
          } else {
            //setPublicationSucces(false)
            ///setLoading(false)
          }
        } else {
          pageNumber++
          if (arrayPublications.length > 0) {
            arrayPublications = [...arrayPublications, ...response.data]
          } else {
            arrayPublications = response.data
          }
          
          var result = arrayPublications
          var currentDay = new Date(date)
          var dayComparation
          var minusDate

         //filtra los datos por fecha para el tiempo de vida de 24 horas las historias
          var fiterDateArray = result.filter(result =>  {          
           dayComparation = new Date(result.createDateUserPublication)
           minusDate = (currentDay - dayComparation)
           console.log('minusDate ->', minusDate)
            if(minusDate < 86400000){
          
             arrayUserHistory.push(
                  {
                  userPublicationId         : result.userPublicationId,
                  userPublicationPhoto      : result.userPublicationPhoto, 
                  createDateUserPublication : result.createDateUserPublication,
                  userId                    : result.userId,
                  totalLikes                : result.totalLikes,
                  totalComments             : result.totalComments,
                  followedId                : result.followedId
                  }  
             )
            }
          })       
    debugger
          setItems(arrayUserHistory)
          //setLoading(false)
         // setPublicationSucces(true)
        }
      })
      .catch(err => {
        console.log('getPublications failed :( review internet service)', err)
      })
  }
  //Arreglo de imagenes del carrusel
 
  //------------------------------------------
  //Empieza un ciclo para recorrer el carrusel
  //------------------------------------------ 
//   const startScroll = () => {
//     debugger
//     // setInterval es una instrucción de javascript que permite ejecutar una función por inervalos de tiempo 
//     timerId = setInterval(slideScroll, 3000)
//   }
  //------------------------------------------------------------
  //Desliza los elmentos del carrusel en incrementos uno por uno
  //------------------------------------------------------------
//   const slideScroll = () => {
//     elementScroll++
//     if (elementScroll < items.length) {
//       if (refFlatList !== null) {
//         //Referencia para ocupar elementos del flatList fuera de la etiqueta
//         refFlatList.current.scrollToIndex({ animated: true, index: elementScroll, viewOffset: 0, viewPosition: 0 })
//         //console.log('hola')
//       }
//     } else {
//       // Devuelve el valor de la posisción del carrusel a la posición inicial
//       elementScroll = -1
//     }
//   }
  //---------------------------
  //Para el avance del carrusel
  //---------------------------
//   const stopScroll = () => {
//     //clearInterval(timerId) es la instrucción para detener la ejecución de setInterval
//     if (timerId) {
//       clearInterval(timerId)
//     }
//   }

  const WIDTH = 500
  //(Dimensions.get('window').height) * .5;
  const sizeItemLayout = (item, index) => (
    { length: WIDTH, offset: WIDTH * index, index }
  );

  return (
    <>
  {
  //....................................................................
  //Sección que pinta las historias en una lista si es que hay hsitorias 
  //....................................................................
  items.length > 0 ? 
    <FlatList
        //refFlatList={React.createRef()}
        ref={refFlatList}
        data={items}
        keyExtractor={(item) => item.userPublicationId.toString()}
        initialScrollIndex={0}
        progressViewOffset={5}
       // getItemLayout={sizeItemLayout}
        // onEndReachedThreshold={1}
        // onEndReached={() => getHistorys()}
        horizontal={true}
        renderItem={({ item, index }) => (
           <CardHistory
           imageUrl={ uriPublications + item.userPublicationPhoto} 
           onPress={ () => {
           var imageUrl = uriPublications + items[index].userPublicationPhoto
           var userId = items[index].followedId  
           var screen = 'FeedScreen' 
            props.navigation.navigate(routes.DETAIL_HITORY, { imageUrl, userId, screen })
           }} 
           thumbnailUrl={ uriPublications + item.userPublicationPhoto} 
           ></CardHistory>
        )}
      />
   :
   <View>
     <Text>no tienes historias por el momento</Text>
   </View>
  }
      
</>
  );
}

const styles = StyleSheet.create({
  background: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  buttonsContainer: {
    padding: 20,
    width: "100%",

  },
  logo: {
    width: 100,
    height: 100,
  },
  logoContainer: {
    position: "absolute",
    top: 70,
    alignItems: "center",
  },
  tagline: {
    fontSize: 25,
    fontWeight: "600",
    paddingVertical: 20,
  },
  image: {
    marginTop: "5%",
    marginBottom: '3%',
    height: 200,
    width: 100,
  },
});

export default HistoryScreen;
